import { useTranslation } from "react-i18next";
import { ShieldCheck, ShieldAlert, Smartphone, MapPin } from "lucide-react";

const META = {
  verified: { Icon: ShieldCheck, cls: "text-success" },
  suspect: { Icon: ShieldAlert, cls: "text-destructive" },
  device: { Icon: Smartphone, cls: "text-muted-foreground" },
  unknown: { Icon: MapPin, cls: "text-muted-foreground" },
};

// شارة حماية الموقع: تُظهر كيف جرى التحقق من مكان العملية (GPS موثّق / تعارض VPN / جهاز / تقريبي).
export const TrustBadge = ({ trust, country }) => {
  const { t } = useTranslation();
  const meta = META[trust] || META.unknown;
  const { Icon } = meta;
  return (
    <p className={`mt-1 flex items-center gap-1.5 text-[11px] font-bold ${meta.cls}`} data-testid="salary-ack-trust">
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span>
        {t(`salaryAck.trust.${trust || "unknown"}`)}
        {trust === "suspect" && country ? t("salaryAck.trust.ipHint", { country }) : ""}
      </span>
    </p>
  );
};
